import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ChildImmunisationRegisterQueryVariables = Types.Exact<{
  input: Types.ChildImmunisationRegisterInput;
}>;


export type ChildImmunisationRegisterQuery = { readonly __typename?: 'Query', readonly childImmunisationRegister?: { readonly __typename?: 'PaginatedChildImmunisationRegister', readonly records?: ReadonlyArray<{ readonly __typename?: 'ChildImmunisationRegisterRecord', readonly bcg?: string | null, readonly hepatitisB0?: string | null, readonly opv0?: string | null, readonly penta1?: string | null, readonly pcv1?: string | null, readonly rota1?: string | null, readonly opv1?: string | null, readonly ipv1?: string | null, readonly penta2?: string | null, readonly pcv2?: string | null, readonly rota2?: string | null, readonly opv2?: string | null, readonly penta3?: string | null, readonly pcv3?: string | null, readonly rota3?: string | null, readonly opv3?: string | null, readonly ipv2?: string | null, readonly vitaminA1?: string | null, readonly vitaminA2?: string | null, readonly measles1?: string | null, readonly yellowFever?: string | null, readonly meningitisA?: string | null, readonly measles2?: string | null, readonly hpv?: string | null, readonly patient: { readonly __typename?: 'Patient', readonly id: string, readonly guardians?: ReadonlyArray<{ readonly __typename?: 'Guardian', readonly phone?: { readonly __typename?: 'SyncablePatientPhone', readonly number: string } | null }> | null, readonly person: { readonly __typename?: 'Person', readonly dob: string, readonly gender: Types.Gender, readonly name: { readonly __typename?: 'Name', readonly fullname?: string | null }, readonly addresses: ReadonlyArray<{ readonly __typename?: 'Address', readonly street?: string | null, readonly ward?: string | null, readonly subCounty?: string | null, readonly state?: string | null, readonly country?: string | null } | null> }, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null } | null } } | null> | null } | null };


export const ChildImmunisationRegisterDocument = gql`
    query ChildImmunisationRegister($input: ChildImmunisationRegisterInput!) {
  childImmunisationRegister(input: $input) {
    records {
      patient {
        id
        guardians {
          phone {
            number
          }
        }
        person {
          name {
            fullname
          }
          dob
          gender
          addresses {
            street
            ward
            subCounty
            state
            country
          }
        }
        meta {
          created
        }
      }
      bcg
      hepatitisB0
      opv0
      penta1
      pcv1
      rota1
      opv1
      ipv1
      penta2
      pcv2
      rota2
      opv2
      penta3
      pcv3
      rota3
      opv3
      ipv2
      vitaminA1
      vitaminA2
      measles1
      yellowFever
      meningitisA
      measles2
      hpv
    }
  }
}
    `;

/**
 * __useChildImmunisationRegisterQuery__
 *
 * To run a query within a React component, call `useChildImmunisationRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildImmunisationRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChildImmunisationRegisterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChildImmunisationRegisterQuery(baseOptions: Apollo.QueryHookOptions<ChildImmunisationRegisterQuery, ChildImmunisationRegisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChildImmunisationRegisterQuery, ChildImmunisationRegisterQueryVariables>(ChildImmunisationRegisterDocument, options);
      }
export function useChildImmunisationRegisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChildImmunisationRegisterQuery, ChildImmunisationRegisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChildImmunisationRegisterQuery, ChildImmunisationRegisterQueryVariables>(ChildImmunisationRegisterDocument, options);
        }
export type ChildImmunisationRegisterQueryHookResult = ReturnType<typeof useChildImmunisationRegisterQuery>;
export type ChildImmunisationRegisterLazyQueryHookResult = ReturnType<typeof useChildImmunisationRegisterLazyQuery>;
export type ChildImmunisationRegisterQueryResult = Apollo.QueryResult<ChildImmunisationRegisterQuery, ChildImmunisationRegisterQueryVariables>;